import { CustomPaymentPurposeType } from './CustomPaymentPurposeType';

export const CustomPaymentPurposeTypeOptions: {
    value: CustomPaymentPurposeType;
    display: string;
}[] = [
    {
        value: CustomPaymentPurposeType.AppraisalAndUnderwritingFee,
        display: 'Appraisal + Underwriting Fee',
    },
    {
        value: CustomPaymentPurposeType.Appraisal,
        display: 'Appraisal',
    },
    {
        value: CustomPaymentPurposeType.UnderwritingFee,
        display: 'Underwriting Fee',
    },
    {
        value: CustomPaymentPurposeType.InterestOrExtension,
        display: 'Interest and/or Extension',
    },
    {
        value: CustomPaymentPurposeType.Other,
        display: 'Other',
    },
];
